import { createFileRoute } from '@tanstack/react-router';
import { AgentAccessGate } from '../../../pages/dashboard/agent/AgentAccessGate';
import { AgentIndexPage } from '../../../pages/dashboard/agent/AgentIndexPage';
import { readSlackInstallOutcome } from '../../../features/agent/slackConnection';
import { readAgentAsk } from '../../../pages/dashboard/agent/agentAsk';

/** `slack` is the literal parameter the gateway's OAuth callback redirects back
 *  with, and the key the router re-serializes into the address bar. Its presence
 *  is also what holds this route on the Slack card instead of forwarding to the
 *  customer's latest thread. */
export interface AgentIndexSearch {
  slack?: string;
  /** An ask to open a new thread with; see `agentAsk.ts`. */
  ask?: string;
}

export const Route = createFileRoute('/dashboard/agent/')({
  validateSearch: (search: Record<string, unknown>): AgentIndexSearch => {
    const ask = readAgentAsk(search.ask);
    return {
      ...(typeof search.slack === 'string' && search.slack !== '' ? { slack: search.slack } : {}),
      ...(ask === undefined ? {} : { ask }),
    };
  },
  component: AgentIndexRoute,
  staticData: { fullBleed: true },
});

function AgentIndexRoute() {
  const { slack, ask } = Route.useSearch();
  return (
    <AgentAccessGate>
      <AgentIndexPage ask={ask} slackOutcome={readSlackInstallOutcome(slack)} />
    </AgentAccessGate>
  );
}
